<template>
    <div class="center" style="width: 60%;">
        <p class="bold font-16">Política de Privacidade do TRUSTGROUP</p>
        <p style="text-align: justify;">
            CONTROLADORA DOS DADOS: TRUST IMPORTAÇÃO E EXPORTAÇÃO EIRELI,
            inscrita no CNPJ/MF sob n. 07.426.908/0001-00, com sede na Rua César Augusto
            Dalçóquio n. 4255, Galpão B, Bairro Salseiros, na cidade de Itajaí/SC CEP 88.311-500, e
            TAGLOG SERVIÇOS LOGÍSTICOS LTDA., inscrita no CNPJ/MF sob n. 10.635.834/0001-
            27, com sede na Rua César Augusto Dalçóquio, n° 4255, Galpão A e B, Salseiros, na cidade
            de Itajaí/SC, CEP 88.311-500, estabelecem, adiante, a Declaração de Privacidade, de
            forma a esclarecer os direitos, obrigações e responsabilidades dos TITULARES DE
            DADOS, clientes do conglomerado TRUSTGROUP.
        </p>
        <p class="bold left">Introdução</p>
        <p style="text-align: justify;">
            Esta é a política de privacidade do Conglomerado TRUSTGROUP (definidos no presente
            documento como "Política" e "Conglomerado TRUSTGROUP", respectivamente), aplicável
            ao TRUSTGROUP e ao conjunto de empresas sob seu controle, e disponível por meio dos
            endereços eletrônicos, a título de exemplo, https://trust.group/,
            https://trust.trinityscp.com.br/, https://trustlog.com.br/, https://trustsuplementos.com.br/,
            http://www.philbra.com.br/empresa, além de outros canais digitais, físicos e mídias sociais,
            conjuntamente definidos como "Plataformas".
            <br /><br />
            Por meio das Plataformas é possível acessar os serviços prestados pelo Conglomerado
            TRUSTGROUP, dentre outras funcionalidades. Nessa Política, explicamos como tratamos
            os dados pessoais dos TITULARES DE DADOS das Plataformas e/ou de terceiros,
            fornecidos ou coletados pelo TRUSTGROUP.
            <br /><br />
            Cada termo iniciado em letra maiúscula utilizado na Política é um termo definido e tem o
            significado a ele atribuído na Política.
            <br /><br />
            A Lei nº 13.709/18, Lei Geral de Proteção de Dados ("LGPD"), é o marco regulatório sobre
            o tema de proteção de dados pessoais e dispõe sobre o tratamento de dados pessoais, em
            meios físicos e digitais, por pessoa natural ou por pessoa jurídica, pública ou privada, com
            objetivo de proteger os direitos fundamentais insertos na Constituição Federal de 1988. A
            LGPD define como "dado pessoal" toda informação relacionada a uma pessoa natural
            identificada ou identificável ("Dados").
            <br /><br />
            Tratamento de Dados refere-se a quaisquer operações realizadas com Dados. Tais
            operações de tratamento incluem coleta, produção, recepção, classificação, utilização,
            acesso, reprodução, transmissão, distribuição, processamento, armazenamento,
            arquivamento, eliminação, avaliação ou controle da informação, modificação, comunicação,
            transferência, difusão ou extração de Dados ("Tratamento").
            <br /><br />
            Essa Política fala sobre o Tratamento de Dados pessoais e/ou outras informações
            fornecidas pelo TITULAR DE DADOS ao navegar, acessar e/ou utilizar as Plataformas,
            bem como dados pessoais e/ou informações coletados pelo TRUSTGROUP, conforme
            aplicável.
            <br /><br />
            Essa Política é aplicável às Plataformas e regula a forma como coletamos e usamos os
            seus dados. Ao acessar e utilizar as Plataformas, o TITULAR DE DADOS expressamente
            declara que leu, compreende e consente sobre a maneira e as formas que realizamos a
            coleta, uso e compartilhamento de seus dados e informações.
            <br /><br />
            Leia atentamente esse documento e caso não concorde com os termos da Política, o
            TITULAR DE DADOS não deverá utilizar as Plataformas.
            <br /><br />
            Toda vez que houver menção aos termos "TRUSTGROUP", "nós" ou "nossos", estaremos
            nos referindo ao conjunto de empresas do TRUSTGROUP; e toda vez que houver menção
            aos termos "Você", "seu", "sua", estaremos nos referindo ao TITULAR DE DADOS.
            <br /><br />
            O TRUSTGROUP respeita sua privacidade e está comprometido em proteger seus dados
            pessoais. Essa política de privacidade informará aos titulares sobre como cuidamos dos
            seus dados pessoais, sejam eles coletados quando visita os sites (https://trust.group/,
            https://trust.trinityscp.com.br/, https://trustlog.com.br/, https://trustsuplementos.com.br/,
            http://www.philbra.com.br/empresa),independentemente de onde o visite, ou de outra forma
            e informa sobre seus direitos de privacidade e como a lei o protege. A política está dividida
            nas seguintes seções:
            <br /><br />
            1. INFORMAÇÃO IMPORTANTE E QUEM SOMOS<br />
            2. OS DADOS QUE COLETAMOS SOBRE VOCÊ<br />
            3. COMO OS SEUS DADOS PESSOAIS SÃO COLETADOS?<br />
            4. COMO USAMOS OS SEUS DADOS PESSOAIS<br />
            5. DIVULGAÇÃO DOS SEUS DADOS PESSOAIS<br />
            6. TRANSFERÊNCIAS INTERNACIONAIS<br />
            7. SEGURANÇA DE DADOS<br />
            8. RETENÇÃO DE DADOS<br />
            9. DIREITOS DOS TITULARES<br />
            10. GLOSSÁRIO<br />
            11. TERCEIROS QUE ACESSAM SEUS DADOS<br />
            12. DO ENCARREGADO DE DADOS PESSOAIS<br />
            13. ALTERAÇÕES DA POLÍTICA DE PRIVACIDADE
        </p>

        <p class="bold left">1. INFORMAÇÕES IMPORTANTE E QUEM SOMOS</p>

        <p class="bold left">Objetivo da política de privacidade</p>
        <p style="text-align: justify;">
            Essa política de privacidade tem como objetivo fornecer informações sobre como a
            TRUSTGROUP coleta e processa seus dados pessoais. Nossos principais meios de coleta
            de dados pessoais são:
            <br /><br />
            1. através do uso do nosso site ou plataformas (incluindo quaisquer dados que você
            possa fornecer através do nosso site ao fazer uma consulta ou adquirir um produto
            ou serviço, assim como quando utiliza qualquer uma de nossas plataformas ou
            soluções);<br />
            2. contato pessoal;<br />
            3. contato telefônico;<br />
            4. o e-mail;<br />
            5. contato das redes sociais;<br />
            6. pesquisas, incluindo pesquisas de referência de crédito/comércio;<br />
            7. consultas / pedidos de bens e serviços;<br />
            8. cartões de visita fornecidos.
            <br /><br />
            Esse site não se destina a crianças e adolescentes e não coletamos intencionalmente
            dados relacionados a eles.
            <br /><br />
            É importante que leia essa POLÍTICA DE PRIVACIDADE, juntamente com as outras
            políticas relacionadas, quando estivermos coletando ou processando dados pessoais sobre
            você, para que esteja totalmente ciente de como e por que estamos usando seus dados.
            Essa POLÍTICA DE PRIVACIDADE complementa outros avisos e políticas de privacidade
            e não se destina a substituí-los.
        </p>

        <p class="bold left">Controlador</p>
        <p style="text-align: justify;">
            O TRUSTGROUP é o controlador e o responsável por seus dados pessoais (referidos como
            "Restaurar", "nós", "nós" ou "nosso" nessa POLÍTICA DE PRIVACIDADE).
            <br /><br />
            Essa POLÍTICA DE PRIVACIDADE é emitida em nome do TRUSTGROUP, portanto,
            quando mencionamos "TRUSTGROUP", "nós" ou “nosso” nessa POLÍTICA DE
            PRIVACIDADE, estamos nos referindo à empresa relevante no grupo e responsável pelo
            processamento de seus dados.
            <br /><br />
            Informaremos qual entidade será a controladora dos seus dados quando comprar um
            produto ou serviço conosco.
            <br /><br />
            Nomeamos um Encarregado de Proteção de Dados (EPD) responsável por supervisionar
            as perguntas relacionadas a essa POLÍTICA DE PRIVACIDADE. Se tiver alguma dúvida
            sobre essa POLÍTICA DE PRIVACIDADE, incluindo quaisquer solicitações para exercer
            seus direitos, entre em contato com o responsável pela proteção de dados, usando os
            detalhes descritos abaixo.
        </p>

        <p class="bold left">Detalhes do contato</p>
        <p style="text-align: justify;">
            Se você tiver alguma dúvida sobre essa POLÍTICA DE PRIVACIDADE ou as práticas de
            privacidade implementadas, entre em contato com nosso Encarregado de Dados Pessoais
            (DPO).
            <br /><br />
            Você tem o direito de apresentar uma reclamação a qualquer momento à Autoridade
            Nacional de Proteção de Dados (ANPD), a autoridade supervisora do Brasil para questões
            de proteção de dados (www.anpd.org.br). No entanto, gostaríamos de ter a oportunidade
            de lidar com suas preocupações antes de abordar a ANPD. Por favor, primeiramente, entre
            em contato conosco.
        </p>

        <p class="bold left">Alterações na política de privacidade e seu dever de nos informar sobre alterações</p>
        <p style="text-align: justify;">
            Mantemos nossa POLÍTICA DE PRIVACIDADE sob constante revisão. As atualizações
            dessa política serão publicadas em nosso site. Quaisquer perguntas, comentários ou
            solicitações referentes a essa política devem ser enviados para dpo@trust.group.
            <br /><br />
            É importante que os dados pessoais que mantemos sobre você sejam precisos e atuais.
            Mantenha-nos informados se seus dados pessoais mudarem durante o seu relacionamento
            conosco.
        </p>

        <p class="bold left">Links de terceiros</p>
        <p style="text-align: justify;">
            Nosso site pode incluir links para sites de terceiros, plug-ins e aplicativos. Clicar nesses
            links ou ativar essas conexões pode permitir que terceiros coletem ou compartilhem seus
            dados. O TRUSTGROUP não tem relação jurídica com esses sites de terceiros e não
            somos responsáveis por suas declarações de privacidade. Quando você sai do nosso site,
            recomendamos que leia a política de privacidade de todos os sites que visitar.
        </p>

        <p class="bold left">2. OS DADOS QUE COLETAMOS SOBRE VOCÊ</p>

        <p style="text-align: justify;">
            Dados pessoais, ou informações pessoais, significa qualquer informação sobre um
            indivíduo a partir do qual essa pessoa possa ser identificada. Não inclui dados em que a
            identidade foi removida (dados anônimos).
            <br /><br />
            Podemos coletar, usar, armazenar e transferir diferentes tipos de dados pessoais que
            agrupamos da seguinte forma:
            <br /><br />
            - Dados de identidade: incluem nome, sobrenome, nome de usuário ou identificador
            semelhante, estado civil, título, data de nascimento, gênero e assinatura digital.<br />
            - Dados de Contato: incluem endereço de cobrança, endereço de entrega, endereço
            de e-mail e números de telefone.<br />
            - Dados Financeiros: incluem detalhes da conta bancária e do cartão de pagamento.<br />
            - Dados de Transação: incluem detalhes sobre pagamentos e outros detalhes de
            produtos e serviços que você comprou.<br />
            - Dados técnicos: incluem o endereço IP (Internet Protocol), seus dados de login,
            tipo e versão do navegador, configuração e localização do fuso horário, tipos e
            versões de plug-in do navegador, sistema e plataforma operacional e outra
            tecnologia nos dispositivos que usa para acessar o site.<br />
            - Dados de perfil: incluem seu nome de usuário e senha, compras ou pedidos feitos,
            seus interesses, preferências, comentários e respostas a pesquisas.<br />
            - Dados de Uso: incluem informações sobre como você usa o site, produtos e
            serviços.<br />
            - Dados de Marketing e Comunicação: incluem suas preferências em receber os
            nossos contatos de marketing e de terceiros e suas preferências de comunicação;<br />
            - Dados Biométricos: incluem o recolhimento de imagens faciais (selfie facial) para
            autenticação da identidade de colaboradores.
            <br /><br />
            Também coletamos, usamos e compartilhamos Dados Agregados, como dados estatísticos
            ou demográficos, para qualquer finalidade. Os dados agregados podem ser derivados de
            seus dados pessoais, mas não são considerados dados pessoais por lei, pois não revelam
            direta ou indiretamente sua identidade. Por exemplo, podemos agregar seus dados de uso
            para calcular a porcentagem de usuários que acessam um recurso específico do site. No
            entanto, se combinarmos ou conectarmos os Dados Agregados aos seus dados pessoais,
            para que possam identificá-lo direta ou indiretamente, trataremos os dados combinados
            como dados pessoais que serão utilizados de acordo com essa POLÍTICA DE
            PRIVACIDADE.
            <br /><br />
            Em nossa responsabilidade de controlador de dados, podemos coletar categorias especiais
            de dados pessoais sobre você (isso inclui detalhes sobre sua raça ou etnia, crenças
            religiosas ou filosóficas, vida sexual, orientação sexual, opiniões políticas, associação
            sindical, informações sobre sua saúde e dados genéticos e biométricos).
            <br /><br />
            Não coletamos nenhuma informação sobre condenações e ofensas criminais. Caso seja
            apontado como operador de dados por terceiros para filtrar, processar, remover ou destruir
            documentos ou informações em qualquer forma física (seja papel, disco, cartão de memória
            ou outro), esses documentos podem conter dados pessoais de categoria especial ou
            informações relacionadas a condenações e ofensas criminais.
        </p>

        <p class="bold left">Se você não fornecer dados pessoais</p>
        <p style="text-align: justify;">
            Nos casos em que precisamos coletar dados pessoais por lei ou sob os termos de um
            contrato que temos com você, e forem fornecidos esses dados quando solicitado, talvez
            não consigamos executar o contrato que temos ou estamos tentando celebrar (por exemplo,
            para fornecer bens ou serviços). Nesse caso, pode haver um cancelamento do produto ou
            serviço que você possui conosco, mas iremos notificá-lo se esse for o caso no momento.
        </p>

        <p class="bold left">Dados pessoais inseridos na plataforma Trinity pelo usuário</p>
        <p style="text-align: justify;">
            Na plataforma Trinity poderá ocorrer de forma indireta a alimentação de dados pessoais via
            upload de documentos pelo próprio usuário, onde estarão localizados esses dados
            pessoais. A plataforma tem a finalidade de acompanhar processos de importação e
            exportação, não fazendo parte disso a coleta de quaisquer dados pessoais além dos
            descritos nessa política, visto que não são necessários para o funcionamento da
            plataforma.
            <br /><br />
            Tomamos todas as medidas necessárias para proteger a plataforma de quaisquer
            vazamentos de dados, estabelecendo medidas de segurança apropriadas para impedir que
            seus dados pessoais sejam acidentalmente perdidos, usados ou acessados de forma não
            autorizada, alterada ou divulgada.
            <br /><br />
            Contudo, caso o usuário alimente deliberadamente a plataforma com dados pessoais além
            dos necessários, nos resguardamos no sentido de que cabe a ele assegurar que sejam
            tomadas todas as medidas possíveis (presentes nas camadas de segurança
            parametrizáveis do próprio sistema ou em sua própria infraestrutura) para garantir que
            esses dados pessoais alimentados manualmente, sensíveis ou não, estejam protegidos de
            quaisquer tipos de acesso, coleta e/ou divulgação, realizados indevidamente.
        </p>

        <p class="bold left">3. COMO OS SEUS DADOS PESSOAIS SÃO COLETADOS?</p>

        <p style="text-align: justify;">
            Utilizamos métodos diferentes para coletar dados de e sobre você, incluindo:
            <br /><br />
            Interações diretas. Você pode nos fornecer seus dados de identidade, contato e dados
            financeiros preenchendo formulários ou correspondendo-nos por pessoalmente, correio,
            telefone, e-mail ou outros. Isso inclui dados pessoais que você fornece quando:
            <br /><br />
            - solicitar nossos produtos ou serviços;<br />
            - crie uma conta em nosso site;<br />
            - assinar nosso serviço ou publicações;<br />
            - solicitar que o marketing seja enviado a você;<br />
            - participar de uma competição, promoção ou pesquisa;<br />
            - forneça seu cartão de visita;<br />
            - nos dê feedback ou entre em contato; ou<br />
            - utiliza nossas plataformas e serviços integrados;
            <br /><br />
            Tecnologias ou interações automatizadas. À medida que você interage com nosso site,
            coletamos automaticamente dados técnicos sobre seu equipamento, ações e padrões de
            navegação. Coletamos esses dados pessoais usando cookies, registros do servidor e
            outras tecnologias semelhantes. Também podemos receber Dados Técnicos sobre você se
            você visitar outros sites que utilizam nossos cookies.
            <br /><br />
            Nosso site utiliza a Solução de Gerenciamento de Cookies “CookieFirst”. Você a encontra
            na página inicial de nosso site (https://trust.group/) e nela pode verificar quais cookies
            utilizamos, no que consiste a política de cookies e definir as configurações, concedendonos ou não, permissão para utilização de cookies de desempenho, funcionais e de
            publicidade. Alguns são necessários ao bom funcionamento do site e não podem ser
            desligados.
            <br /><br />
            Nós também utilizamos o Google SiteKit, recurso que permite o acesso a informações do
            buscador do Google, Analytics, AdSense e PageSpeed Insights, servindo para conhecer
            como os usuários encontram e utilizam nosso site.
            <br /><br />
            Também usamos o Easy WP SMTP, recurso que permite a configuração uma conta de email no WordPress, definida de acordo com os dados de autenticação e métodos de envio
            determinados pelo servidor de e-mail.
            <br /><br />
            Terceiros ou fontes publicamente disponíveis. Nós receberemos dados pessoais sobre
            você de vários terceiros e fontes públicas, conforme estabelecido abaixo:
            <br /><br />
            - Dados técnicos das seguintes partes:<br />
            - provedores de análises, como o Google com sede fora do Brasil;<br />
            - redes de publicidade baseadas no Brasil; e<br />
            - procurar fornecedores de informação no Brasil.<br />
            - Dados de contato, financeiros e de transações de fornecedores de serviços técnicos, de
            pagamento e entrega baseados no Brasil.<br />
            - Dados de identidade e contato de agências de referência e comércio de crédito no Brasil.<br />
            - Dados de identidade e contato de fontes publicamente disponíveis, como CPF e o Registro
            Eleitoral.
        </p>

        <p class="bold left">4. COMO USAMOS SEUS DADOS PESSOAIS</p>

        <p style="text-align: justify;">
            Só usaremos seus dados pessoais quando a lei nos permitir. Geralmente, usaremos seus
            dados pessoais nas seguintes circunstâncias:
            <br /><br />
            - Ao executar o contrato ou quando estamos prestes a celebrar.<br />
            - Ao aplicar os legítimos interesses do TRUSTGROUP (ou de terceiros), desde que
            não afetem os seus interesses e direitos fundamentais nem os substituem.<br />
            - Ao cumprir uma obrigação legal.
            <br /><br />
            Consulte o Glossário na seção 10 para descobrir mais sobre os tipos de bases legais em
            que confiaremos para processar seus dados pessoais.
        </p>

        <p class="bold left">Finalidades para as quais usaremos seus dados pessoais</p>
        <p style="text-align: justify;">
            Estabelecemos abaixo, em formato de tabela, uma descrição de todas as maneiras pelas
            quais planejamos usar seus dados pessoais e em quais bases jurídicas nos baseamos.
            Também identificamos quais são nossos interesses legítimos quando apropriado.
            <br /><br />
            Observe que podemos processar seus dados pessoais por mais de um motivo legal,
            dependendo da finalidade específica para a qual estamos usando seus dados. Entre em
            contato conosco se precisar de detalhes sobre o fundamento legal específico em que
            estamos confiando para processar seus dados pessoais, onde mais de um fundamento foi
            estabelecido na tabela abaixo.
        </p>

        <table class="mt-8 mb-8">
            <thead>
                <tr style="background: black; color: white;">
                    <th>Objetivo / Atividade</th>
                    <th>Tipo de dados</th>
                    <th>Base legal para processamento, incluindo base de interesse legítimo</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Para registrar você como um novo cliente</td>
                    <td>
                        (a) Identidade <br />
                        (b) Contato
                    </td>
                    <td>
                        (a) Execução de um contrato com você; <br />
                        (b) Consentimento do Titular.
                    </td>
                </tr>
                <tr>
                    <td>
                        Para processar e entregar seu pedido, incluindo:<br />
                        (a) Gerenciar pagamentos, taxas e encargos;<br />
                        (b) Coletar e recuperar o dinheiro devido a nós
                    </td>
                    <td>
                        (a) Identidade<br />
                        (b) Contato <br />
                        (c) Perfil <br />
                        (d) Marketing e comunicações
                    </td>
                    <td>
                        (a) Execução de um contrato com você; <br />
                        (b) Necessário para nossos interesses legítimos (recuperar dívidas que nos são devidas).
                    </td>
                </tr>
                <tr>
                    <td>
                        Para gerenciar nosso relacionamento com você, que incluirá: <br />
                        (a) Notificá-lo sobre alterações em nossos termos ou política de privacidade <br />
                        (b) Solicitando que você deixe um comentário ou faça uma pesquisa
                    </td>
                    <td>
                        (a) Identidade<br />
                        (b) Contato <br />
                        (c) Perfil <br />
                        (d) Marketing e comunicações
                    </td>
                    <td>
                        (a) Execução de um contrato com você;<br />
                        (b) Necessário para cumprir uma obrigação legal;<br />
                        (c) Necessário para nossos interesses legítimos (manter nossos registros atualizados e estudar como os clientes usam nossos produtos / serviços);<br />
                        (d) Consentimento do Titular.
                    </td>
                </tr>
                <tr>
                    <td>
                        Para permitir que você participe de um sorteio, concorra ou complete uma pesquisa.
                    </td>
                    <td>
                        (a) Identidade<br />
                        (b) Contato <br />
                        (c) Perfil <br />
                        (d) Uso <br />
                        (e) Marketing e comunicações
                    </td>
                    <td>
                        (a) Execução de um contrato com você;<br />
                        (b) Consentimento do Titular.
                    </td>
                </tr>
                <tr>
                    <td>
                        Para administrar e proteger nossos negócios e esse site
                        (incluindo solução de problemas, análise de dados, testes, manutenção do sistema, suporte, relatório e hospedagem de dados)
                    </td>
                    <td>
                        (a) Identidade<br />
                        (b) Contato <br />
                        (c) Técnico
                    </td>
                    <td>
                        (a) Necessário para nossos interesses legítimos (para administrar nossos negócios, provisão de serviços administrativos e de TI, segurança de rede, para evitar fraudes e no contexto de um exercício de reorganização comercial ou de reestruturação de grupo) <br />
                        (b) Necessário para cumprir uma obrigação legal Para lhe fornecer conteúdo e anúncios relevantes do site e avaliar ou entender a eficácia da publicidade que veiculamos a você
                    </td>
                </tr>
                <tr>
                    <td>
                        Para lhe fornecer conteúdo e anúncios relevantes do site e avaliar ou entender a eficácia da publicidade que veiculamos a você.
                    </td>
                    <td>
                        (a) Identidade<br />
                        (b) Contato <br />
                        (c) Perfil <br />
                        (d) Uso <br />
                        (e) Marketing e comunicações <br />
                        (f) Técnico
                    </td>
                    <td>
                        (a) Necessário para nossos interesses legítimos (estudar como os clientes usam nossos produtos / serviços, desenvolvê-los, expandir nossos negócios e informar nossa estratégia de marketing); <br />
                        (b) Execução de um contrato com você; <br />
                        (c) Consentimento do Titular.
                    </td>
                </tr>
                <tr>
                    <td>
                        Para usar a análise de dados para melhorar seu site, produtos / serviços, marketing, relacionamento com clientes e experiências
                    </td>
                    <td>
                        (a) Técnico<br />
                        (b) Uso
                    </td>
                    <td>
                        Necessário para nossos interesses legítimos (definir tipos de clientes para nossos produtos e serviços, manter nosso site atualizado e relevante, desenvolver nossos negócios e informar nossa estratégia de marketing).
                    </td>
                </tr>
                <tr>
                    <td>
                        Para fazer sugestões e recomendações sobre bens ou serviços que possam ser do seu interesse
                    </td>
                    <td>
                        (a) Identidade <br />
                        (b) Contato <br />
                        (c) Técnico <br />
                        (d) Uso <br />
                        (e) Perfil <br />
                        (f) Marketing e comunicações
                    </td>
                    <td>
                        Necessário para nossos interesses legítimos (desenvolver nossos produtos / serviços e expandir nossos negócios).
                    </td>
                </tr>
                <tr>
                    <td>
                        Para proteção de crédito
                    </td>
                    <td>
                        (a) Identidade <br />
                        (b) Contato <br />
                        (c) Técnico <br />
                        (d) Uso <br />
                        (e) Perfil <br />
                        (f) Marketing e comunicações <br />
                        (g) Biométricos <br />
                    </td>
                    <td>
                        (a) Necessário para nossos interesses legítimos (estudar como os clientes usam nossos produtos / serviços, desenvolvê-los, expandir nossos negócios e informar nossa estratégia de marketing); <br />
                        (b) Execução de um contrato com você; <br />
                        (c) Consentimento do Titular; <br />
                        (d) Necessário para nossos interesses legítimos (proteger as transações contra fraudes bancárias que colocam em risco os titulares de dados); <br />
                        (e) Necessário para o cumprimento de obrigação legal. Para realizar o seu cadastro na plataforma Trinity
                    </td>
                </tr>
                <tr>
                    <td>
                        Para realizar o seu cadastro na plataforma Trinity.
                    </td>
                    <td>
                        (a) Nome de usuário <br />
                        (b) E-mail
                    </td>
                    <td>
                        (a) Execução de um contrato com você; <br />
                        (b) Consentimento do Titular.
                    </td>
                </tr>
                <tr>
                    <td>
                        Para enriquecer o seu cadastro de usuário na plataforma (dados não obrigatórios).
                    </td>
                    <td>
                        (a) Foto de usuário <br />
                        (b) Telefone celular <br />
                        (c) Nome do representante legal da empresa <br />
                        (d) Nome do responsável operacional da empresa <br />
                        (e) E-mail do representante legal da empresa <br />
                        (f) E-mail do representante operacional da empresa
                    </td>
                    <td>
                        (a) Consentimento do Titular.
                    </td>
                </tr>
                <tr>
                    <td>
                        Para enviar notificações de rastreamento e relatórios recorrentes da plataforma Trinity
                    </td>
                    <td>
                        (a) E-mail <br />
                        (b) Telefone celular
                    </td>
                    <td>
                        (a) Execução de um contrato com você; <br />
                        (b) Consentimento do Titular.
                    </td>
                </tr>
            </tbody>
        </table>

        <p class="bold left">Marketing</p>
        <p style="text-align: justify;">
            Nós nos esforçamos para fornecer opções a respeito de determinados usos de dados
            pessoais, principalmente em relação a marketing e publicidade.
        </p>

        <p class="bold left">Nossas Ofertas promocionais</p>
        <p style="text-align: justify;">
            Podemos usar seus dados de identidade, contato, técnico, uso e perfil para formar uma
            visão do que achamos que você pode querer ou precisar, ou o que pode ser do seu
            interesse. É assim que decidimos quais produtos, serviços e ofertas podem ser relevantes
            para você (chamamos isso de marketing).
            <br /><br />
            Você receberá nossas comunicações de marketing se tiver solicitado informações ou
            adquirido bens ou serviços e não tiver optado por não receber esse marketing.
        </p>

        <p class="bold left">Marketing de terceiros</p>
        <p style="text-align: justify;">
            Obteremos seu consentimento expresso antes de compartilharmos seus dados pessoais
            com terceiros, para fins de marketing.
        </p>

        <p class="bold left">Optar por não participar</p>
        <p style="text-align: justify;">
            Você pode solicitar a nós ou a terceiros que parem de enviar mensagens de marketing a
            qualquer momento, entrando em contato conosco a qualquer momento.
            <br /><br />
            Quando você optar por não receber essas mensagens de marketing, isso não se aplicará
            aos dados pessoais fornecidos a nós como resultado de uma compra de produto / serviço,
            experiência em produto / serviço ou outras transações.
        </p>

        <p class="bold left">Biometria</p>
        <p style="text-align: justify;">
            Utilizamos dos dados biométricos para a realização da autenticação por esse meio, com a
            finalidade de implementar mecanismos de segurança da informação contra fraudes de
            terceiros mal-intencionados. O objetivo do recolhimento é garantir ao TITULAR maior
            proteção física e jurídica dentro do TRUSTGROUP.
        </p>

        <p class="bold left">Mudança de propósito</p>
        <p style="text-align: justify;">
            Somente usaremos seus dados pessoais para os fins que coletamos, a menos que
            consideremos razoavelmente que precisamos usá-los por outro motivo e esse motivo seja
            compatível com o objetivo original. Se você deseja obter uma explicação sobre como o
            processamento para a nova finalidade é compatível com a finalidade original, entre em
            contato conosco.
            <br /><br />
            Se precisarmos usar seus dados pessoais para fins não relacionados, notificaremos você
            e explicaremos a base legal que nos permite fazê-lo.
            <br /><br />
            Observe que podemos processar seus dados pessoais sem o seu conhecimento ou
            consentimento, em conformidade com as regras acima, quando isso for exigido ou permitido
            por lei.
        </p>

        <p class="bold left">5. DIVULGAÇÃO DOS SEUS DADOS PESSOAIS</p>

        <p style="text-align: justify;">
            Podemos compartilhar seus dados pessoais com as partes estabelecidas abaixo para os
            fins estabelecidos na tabela na seção 4 acima.
            <br /><br />
            - Terceiros Internos, conforme estabelecido no Glossário na seção 10.<br />
            - Terceiros externos, conforme estabelecido no Glossário na seção 10.<br />
            - Terceiros para os quais podemos optar por vender, transferir ou mesclar partes de
            nossos negócios ou ativos. Como alternativa, podemos procurar adquirir outros
            negócios ou fundir-se com eles. Se ocorrer uma alteração em nossos negócios, os
            novos proprietários poderão usar seus dados pessoais da mesma maneira que
            estabelecido nessa política de privacidade.
            <br /><br />
            Exigimos que todos os terceiros respeitem a segurança dos seus dados pessoais e os
            tratem de acordo com a lei. Não permitimos que nossos provedores de serviços
            terceirizados usem seus dados pessoais para seus próprios fins e apenas permitimos que
            eles processem seus dados pessoais para fins especificados e de acordo com nossas
            instruções.
        </p>

        <p class="bold left">6. TRANSFERÊNCIAS INTERNACIONAIS</p>

        <p style="text-align: justify;">
            Nós realizamos importação e exportação de produtos e serviços para vários países do
            mundo, transferindo continuamente dados de estrangeiros e brasileiros. Garantimos que as
            empresas com quem nos relacionamos têm o mesmo nível de proteção de dados pessoais
            com os quais aplicamos aqui no Brasil. Se, por um acaso, o nível de proteção for menor do
            que aplicamos aqui, utilizaremos das normas protetivas brasileiras.
        </p>

        <p class="bold left">7. SEGURANÇA DE DADOS</p>

        <p style="text-align: justify;">
            Estabelecemos medidas de segurança apropriadas para impedir que seus dados pessoais
            sejam acidentalmente perdidos, usados ou acessados de forma não autorizada, alterada
            ou divulgada. Além disso, limitamos o acesso aos seus dados pessoais aos funcionários,
            agentes, contratados e outros terceiros. Eles apenas processam seus dados pessoais de
            acordo com nossas instruções e estão sujeitos a um dever de confidencialidade.
            Estabelecemos procedimentos para lidar com qualquer suspeita de violação de dados
            pessoais e notificaremos você e qualquer órgão regulador aplicável sobre uma violação
            onde for legalmente exigido.
        </p>

        <p class="bold left">8. RETENÇÃO DE DADOS</p>

        <p class="bold left">Por quanto tempo serão usados os dados pessoais?</p>
        <p style="text-align: justify;">
            Somente reteremos seus dados pessoais pelo tempo que for razoavelmente necessário
            para cumprir as finalidades para as quais foram coletados, inclusive para atender a
            quaisquer requisitos legais, regulamentares, tributários, criminais, contábeis ou de
            relatórios.
            <br /><br />
            Podemos reter seus dados pessoais por um período mais longo no caso de uma
            reclamação ou se acreditarmos razoavelmente que há uma perspectiva de litígio em relação
            ao nosso relacionamento com você.
            <br /><br />
            Para determinar o período de retenção apropriado para dados pessoais, consideramos a
            quantidade, a natureza e a sensibilidade dos dados pessoais, o risco potencial de danos
            por uso não autorizado ou divulgação de seus dados pessoais, os objetivos para os quais
            processamos seus dados pessoais e se pode atingir esses objetivos por outros meios e
            pelos requisitos legais, regulamentares, tributários, contábeis ou outros aplicáveis.
            <br /><br />
            Por lei, precisamos manter as informações básicas sobre nossos clientes (incluindo dados
            de contato, identidade, dados financeiros e de transação) por seis anos após deixarem de
            ser clientes para fins fiscais.
            <br /><br />
            Em algumas circunstâncias, pode ser solicitado que excluamos seus dados: consulte a
            seção 9 abaixo para obter mais informações.
            <br /><br />
            Em algumas circunstâncias, anonimizaremos seus dados pessoais (para que não possam
            mais ser associados a você) para fins de pesquisa ou estatísticas; nesse caso, poderemos
            usar essas informações indefinidamente, sem aviso prévio.
        </p>

        <p class="bold left">9. DIREITOS DOS TITULARES</p>

        <p style="text-align: justify;">
            Sob certas circunstâncias, você tem direitos sob as leis de proteção de dados em relação
            aos seus dados pessoais, dentre eles:
            <br /><br />
            - Solicite acesso aos seus dados pessoais.<br />
            - Solicitar correção de seus dados pessoais.<br />
            - Solicite o apagamento dos seus dados pessoais.<br />
            - Objete o processamento de seus dados pessoais.<br />
            - Solicite restrição ao processamento de seus dados pessoais.<br />
            - Solicite a transferência de seus dados pessoais.<br />
            - Direito de retirar o consentimento.
            <br /><br />
            Solicitar acesso aos seus dados pessoais (geralmente conhecido como "solicitação de
            acesso ao titular dos dados"). Isso permite que você receba uma cópia dos dados pessoais
            que mantemos sobre você e verifique se estamos processando legalmente.
            <br /><br />
            Solicitar correção dos dados pessoais que mantemos sobre você. Isso permite que
            você corrija os dados incompletos ou imprecisos que mantemos sobre você, embora
            possamos precisar verificar a precisão dos novos dados que você nos fornece.
            <br /><br />
            Solicitar a eliminação dos seus dados pessoais. Isso permite que você solicite a
            exclusão ou remoção de dados pessoais onde não há boas razões para continuarmos a
            processá-los. Você também tem o direito de solicitar que excluamos ou remova seus dados
            pessoais nos casos em que tenha exercido com sucesso o seu direito de se opor ao
            processamento (veja abaixo), onde podemos ter processado suas informações ilegalmente
            ou onde somos obrigados a apagar seus dados pessoais para cumprir a lei local. Observe,
            no entanto, que nem sempre podemos atender à sua solicitação de exclusão por razões
            legais específicas que serão notificadas a você, se aplicável, no momento da sua
            solicitação.
            <br /><br />
            Objetar o processamento de seus dados pessoais onde confiamos em um interesse
            legítimo (ou de terceiros) e há algo sobre sua situação em particular que faz com que você
            queira opor-se ao processamento por esse motivo, pois sente que isso afeta seus
            interesses fundamentais direitos e liberdades. Você também tem o direito de objetar onde
            estamos processando seus dados pessoais para fins de marketing direto. Em alguns casos,
            podemos demonstrar que temos fundamentos legítimos convincentes para processar suas
            informações que substituem seus direitos e liberdades.
            <br /><br />
            Solicitar restrição de processamento de seus dados pessoais. Isso permite que você
            solicite a suspensão do processamento de seus dados pessoais nos seguintes cenários:
            <br /><br />
            - Se você deseja que estabeleçamos a precisão dos dados.<br />
            - Onde nosso uso dos dados é ilegal, mas você não deseja que ele seja apagado.<br />
            - Onde você precisa que mantenha os dados, mesmo que não exijamos mais, pois<br />
            você precisa estabelecer, exercer ou defender reivindicações legais.<br />
            - Você se opôs ao uso de seus dados, mas precisamos verificar se temos motivos<br />
            legítimos para usá-los.
            <br /><br />
            Solicitar a transferência de seus dados pessoais para você ou para terceiros.
            Forneceremos a você, ou a terceiros que você escolheu, seus dados pessoais em um
            formato legível por máquina estruturado, comumente usado. Observe que esse direito se
            aplica apenas a informações automatizadas que você inicialmente forneceu consentimento
            para usarmos ou onde usamos as informações para executar um contrato com você.
            <br /><br />
            Retirar o consentimento a qualquer momento em que confiamos no consentimento
            para processar seus dados pessoais. No entanto, isso não afetará a legalidade de
            qualquer processamento realizado antes de você retirar seu consentimento. Se você retirar
            seu consentimento, talvez não possamos fornecer certos produtos ou serviços a você.
            Aconselharemos se esse for o caso no momento em que você retirar seu consentimento.
            <br /><br />
            Se você deseja exercer algum dos direitos descritos acima, entre em contato conosco.
        </p>

        <p class="bold left">Nenhuma taxa é necessária</p>
        <p style="text-align: justify;">
            Você não terá que pagar uma taxa para acessar seus dados pessoais (ou para exercer
            qualquer outro direito). No entanto, se sua solicitação for claramente infundada, repetitiva
            ou excessiva, podemos nos recusar a atender sua solicitação nessas circunstâncias.
        </p>

        <p class="bold left">O que podemos precisar de você</p>
        <p style="text-align: justify;">
            Podemos precisar solicitar informações específicas de você para nos ajudar a confirmar
            sua identidade e garantir seu direito de acessar seus dados pessoais (ou de exercer
            quaisquer outros direitos). Essa é uma medida de segurança para garantir que os dados
            pessoais não sejam divulgados a qualquer pessoa que não tenha o direito de recebê-los.
            Também podemos entrar em contato com você para solicitar mais informações em relação
            à sua solicitação para acelerar nossa resposta.
        </p>

        <p class="bold left">Prazo para responder</p>
        <p style="text-align: justify;">
            Tentamos responder a todos os pedidos legítimos dentro de 15 (quinze) dias.
            Ocasionalmente, pode levar mais de um mês se sua solicitação for particularmente
            complexa ou se você tiver feito várias solicitações. Nesse caso, iremos notificá-lo e mantêlo atualizado.
        </p>

        <p class="bold left">10. GLOSSÁRIO</p>

        <p style="text-align: justify;">
            Interesse legítimo: significa o interesse da empresa na condução e gerenciamento de
            nossos negócios, para que possamos oferecer o melhor serviço/produto e a melhor e mais
            segura experiência. Garantimos que consideramos e equilibramos qualquer impacto
            potencial sobre você (positivo e negativo) e seus direitos antes de processarmos seus
            dados pessoais para nossos interesses legítimos. Nós não usamos seus dados pessoais
            para atividades em que nossos interesses são substituídos pelo impacto sobre você (a
            menos que tenhamos seu consentimento ou que seja exigido ou permitido por lei). Você
            pode obter mais informações sobre como avaliamos nossos interesses legítimos em
            relação a qualquer impacto potencial sobre você em relação a atividades específicas,
            entrando em contato conosco por meio do e-mail: dpo@trust.group.
            <br /><br />
            Execução do Contrato: significa processar seus dados onde for necessário para a
            execução de um contrato do qual você é parte ou tomar medidas a seu pedido antes de
            celebrar esse contrato.
            <br /><br />
            Cumprir uma obrigação legal: significa processar seus dados pessoais sempre que
            necessário para cumprir uma obrigação legal a que estamos sujeitos.
        </p>

        <p class="bold left">11. TERCEIROS QUE ACESSAM SEUS DADOS</p>

        <p class="bold left">Terceiros Internos</p>
        <p style="text-align: justify;">
            O TRUSTGROUP possui filiais e escritórios espalhados pelo Brasil, atuando como
            controladores ou processadores conjuntos e com sede no Brasil e prestam serviços
            relacionados ou complementares.
        </p>

        <p class="bold left">Terceiros externos</p>
        <p style="text-align: justify;">
            Provedores de serviços que atuam como processadores baseados no Brasil que
            fornecem serviços de administração de TI e de sistema.
            <br /><br />
            Consultores profissionais que atuam como operadores, incluindo advogados,
            banqueiros, auditores e seguradoras com sede no Brasil, que prestam serviços de
            consultoria, serviços bancários, jurídicos, seguros e contabilidade.
            <br /><br />
            Servidores da Receita Federal, reguladores e outras autoridades que atuam como
            processadores ou controladores conjuntos com sede no Brasil que exigem relatar
            atividades de processamento em determinadas circunstâncias.
            <br /><br />
            Provedores de débito, crédito e cartão de crédito, com sede no Brasil, que fornecem
            meios de pagamento e serviços relacionados.
        </p>

        <p class="bold left">12. DO ENCARREGADO DE DADOS PESSOAIS</p>

        <p style="text-align: justify;">
            Para assuntos relacionados ao tratamento de dados pessoais, o interessado deverá entrar
            em contato com o Encarregado, que é MARIANA GONÇALVES, conforme dados abaixo:
            <br /><br />
            E-MAIL: dpo@trust.group.<br />
            CONTATO: (47) 3405-8300<br />
            Horários de atendimento:<br />
            Segunda a Sexta das 8h00min às 18h00min.
        </p>

        <p class="bold left">13. ALTERAÇÕES DA POLÍTICA DE PRIVACIDADE</p>

        <p style="text-align: justify;">
            Em busca de uma contínua evolução de suas práticas, o TRUSTGROUP poderá alterar a
            qualquer momento a sua POLÍTICA DE PRIVACIDADE, sendo que as alterações serão
            divulgadas em seus sites, nos contatos fornecidos pelo TITULAR DE DADOS e no
            PORTAL DE PRIVACIDADE, para serem consultados a qualquer tempo.
        </p>
    </div>
</template>

<script>
export default {
  name: 'PrivacyView',
};
</script>

<style>

</style>
